import {observable, computed, action} from 'mobx';
import {getIn} from '../utils';
import createSelector, {LruCacheObject} from 're-reselect';

export class TimeUnit {
  @observable content = {};

  constructor(content) {
    this.content = content;
  }

  @computed get id() {
    return this.content.refAllotmentTimeUnitId;
  }

  @computed get name() {
    return this.content.AllotmentTimeUnitId_Name;
  }

  @computed get timeLengthSec() {
    return this.content.timeLengthSec;
  }
}

export class Organization {
  @observable content = {};

  constructor(api) {
    this.api = api;
  }

  @computed get isShowingTeasers() {
    return !getIn(this.content, ['HideTeaserObjects']);
  }

  @computed get ccgwUppUrl() {
    return getIn(this.content, ['DataTransUPPUrl']);
  }

  @computed get timeUnits() { 
    return getIn(this.content, ['OrganizationDurationAllotmentTimeUnit'], []).map(o => new TimeUnit(o));
  }

  @computed get refAllotmentTimeUnitId() {
    return getIn(this.content, ['refAllotmentTimeUnitId']);
  }

  @computed get showSchedulesInBW() {
    return getIn(this.content, ['ShowSchedulesInBW']);
  }

  @computed get minPickupTime() {
    return getIn(this.content, ['minPickupTime']);
  }

  @computed get settings() {
    return getIn(this.content, ['settings']);
  }

  timeUnitById(id) {
    return this.timeUnits.find(o => o.id === id) || {};
  }

  @computed get name() { return getIn(this.content, ['Name']) }
  @computed get claim() { return getIn(this.content, ['Claim']) }
  @computed get id() {return getIn(this.content, ['Id'])}
  @computed get isClosedUserGroup() {return getIn(this.content, ['IsClosedUserGroup'])}

  @action async fetch({orgId}) {
    if(this._loadingPromise) {
      return this._loadingPromise;
    }
    if(orgId !== this.id) {
      this._loadingPromise = this.api.getOrganization({
        organizationId: orgId,
      })
      try{ 
        this.content = await this._loadingPromise;
      }
      finally {
        this._loadingPromise = undefined;
      }
    }
  }

  cFetch = createSelector(
    [p => p],
    (p) => this.fetch(p)
  )(
    ({orgId}) => 
      `${orgId}`,
    {cacheObject: new LruCacheObject({cacheSize: 1}), }
  );   
}


// WEBPACK FOOTER //
// ./src/model/Organization.js